export enum PopupTypeEnum {
  Image = 1,
  Link = 2,
}
